import { MemberBadge } from 'src/features/shared/components/MemberBadge'
import { Schemas } from '~/api/gen'
import { Img } from '~/components/elements/Img'
import { ItemDisplayPrice } from '~/components/elements/ItemDisplayPrice'
import fallbackIcon from '~/images/user_80.gif'

const PAGE_SIZE = 10

export type Props = {
  relatedProducts: Schemas.get_product_with_members_response
}

export const RelatedProductList: React.FC<Props> = ({ relatedProducts }) => {
  const totalCount = relatedProducts.total_count
  if (totalCount < 4) return null

  return (
    <section>
      <div className="relative">
        <h2 className="pl-4 text-[14px] font-bold leading-none">
          関連フリマアイテム
        </h2>
        {totalCount >= PAGE_SIZE && (
          <p className="absolute right-4 top-0 leading-none">
            <a
              href="https://wearapp.page.link/SJqFT2T9NNhM3VRE6"
              target="_blank"
              rel="noreferrer"
              className="text-[14px] font-bold text-blue-500"
              aria-label="関連フリマアイテムをアプリでもっと見る"
            >
              アプリでもっと見る
            </a>
          </p>
        )}
      </div>
      <div className="w-screen overflow-x-scroll py-4 hide-scroll">
        <ul className="relative mx-4 inline-flex overflow-hidden rounded-lg shadow-folder-item">
          {relatedProducts.products.map(
            (product: Schemas.product_with_member) => {
              return (
                <li key={product.key}>
                  <a href={`/products/${product.key}/`}>
                    <div className="relative flex">
                      <Img
                        src={product.ppf_images[0]?.url ?? ''}
                        width={125}
                        height={150}
                        alt={product.ppf_title}
                        className="h-[150px] max-w-none object-cover"
                      />
                      <p className="absolute bottom-[6px] left-[6px] leading-none">
                        <ItemDisplayPrice
                          displayPrice={product.display_price}
                          type="PRODUCT"
                        />
                      </p>
                    </div>
                  </a>
                  <a href={`/${product.member.user_name}/`}>
                    <p className="flex w-full items-center space-x-1 pb-4 pl-2 pt-2">
                      <span className="relative inline-block size-6 overflow-hidden rounded-full border border-gray-300">
                        <Img
                          src={product.member.image.url_80 ?? fallbackIcon}
                          width={24}
                          height={24}
                          alt=""
                        />
                      </span>
                      <span className="max-w-[64px] truncate text-[11px] font-bold leading-[1.6]">
                        {product.member.nick_name}
                      </span>
                      <MemberBadge
                        member={product.member}
                        className="ml-[7px] mt-[-1px] size-[15px]"
                      />
                    </p>
                  </a>
                </li>
              )
            }
          )}
        </ul>
      </div>
    </section>
  )
}
